import { Mailbox } from "types/api/mailbox";

// The mailbox address as users type it into a merchant's checkout form.
export interface MailboxAddress {
  name: string;
  street: string;
  // "Suite SB1475": the suite/box line users must put in Address line 2.
  suiteLine: string;
  city: string;
  zip: string;
  phone: string;
  // "city, zip" as one line, the way the copied text shows it.
  cityLine: string;
  // Every non-empty line joined with newlines: what "Copy address" copies.
  fullAddress: string;
}

const text = (value: unknown): string => (value == null ? "" : String(value));

// The one place that decides what the mailbox address is. The Mailboxes page
// and the Storage demo card both build from it, so what users copy is the
// same on both surfaces. `suiteLine` arrives translated; this stays pure data.
export const buildMailboxAddress = (
  mailbox: Mailbox,
  fullName: string | null,
  suiteLine: string,
): MailboxAddress => {
  const name = text(fullName);
  const street = text(mailbox.street);
  const city = text(mailbox.city);
  const zip = text(mailbox.zip_code);
  const phone = text(mailbox.phone);
  const cityLine = [city, zip].filter(Boolean).join(", ");
  const fullAddress = [name, street, suiteLine, cityLine, phone]
    .filter(Boolean)
    .join("\n");

  return { name, street, suiteLine, city, zip, phone, cityLine, fullAddress };
};
